import {getFormProps, getInputProps, useForm} from '@conform-to/react'
import {parseWithZod} from '@conform-to/zod'
import {useFetcher} from '@remix-run/react'
import {Button, TextField} from '@translated/babele-react'
import React, {useEffect} from 'react'

import {Dialog, DialogContent, DialogTrigger} from '~/ui/Modal'
import {addMemorySchema, type AddMemoryAction} from '../_action.memory'

export const AddMemoryDialog = ({children}: {children: React.ReactNode}) => {
  const [isAddMemoryModalOpen, setIsAddMemoryModalOpen] = React.useState(false)

  return (
    <Dialog open={isAddMemoryModalOpen} onOpenChange={setIsAddMemoryModalOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent>
        <AddMemoryForm onSuccess={() => setIsAddMemoryModalOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

function AddMemoryForm({onSuccess}: {onSuccess?: () => void}) {
  const fetcher = useFetcher<AddMemoryAction>()
  const [form, fields] = useForm({
    onValidate: ({formData}) => {
      return parseWithZod(formData, {schema: addMemorySchema})
    },
    lastResult: fetcher.data,
    id: 'add-memory',
  })

  const isSuccess = fetcher.data?.status == 'success'

  useEffect(() => {
    if (isSuccess) onSuccess?.()
  }, [isSuccess, onSuccess])

  return (
    <fetcher.Form {...getFormProps(form)} action="/memory" method="POST">
      <div className="flex flex-col gap-8 py-6">
        <h2 className="text-display-md text-center">Add memory</h2>
        <div className="flex flex-col gap-4">
          <TextField
            {...getInputProps(fields.name, {type: 'text'})}
            placeholder="Memory name"
            aria-label="Memory name"
          />
          {form.errors && (
            <div className="p-4 bg-critical-100 text-critical-800">
              {form.errors}
            </div>
          )}
          <Button
            isLoading={fetcher.state != 'idle'}
            variant={{tone: 'primary'}}
            type="submit"
            name="_action"
            value="addMemory"
          >
            Add memory
          </Button>
        </div>
      </div>
    </fetcher.Form>
  )
}
